export default "__VITE_ASSET__a665cba5__"